export const helperChipsOptions = [
  {
    title: "Navigate the Portal",
    url: "https://support.calebandbrown.com/en/articles/5826680-navigating-the-portal",
  },
  {
    title: "Verify Your Account",
    url: "https://support.calebandbrown.com/en/articles/6153990-creating-your-caleb-brown-portal-account",
  },
  {
    title: "Deposit",
    url: "https://support.calebandbrown.com/en/articles/3129827-how-do-i-deposit-fiat",
  },
  {
    title: "Trade",
    url: "https://arc.net/l/quote/nzesjswq",
  },
];

export type optionsType = { group: "marketing" | "brokerage" | "fund"; label: string };

export const options: optionsType[] = [
  { group: "marketing", label: "Marketing offers and product launches" },
  { group: "brokerage", label: "Market insights" },
  { group: "fund", label: "Fund news" },
];
